import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("ErrorBoundary caught an error:", error, errorInfo);

        // Send to our backend
        const reportError = async () => {
            try {
                await fetch(`${process.env.REACT_APP_API_URL || ''}/api/report-error`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        error: error.toString(),
                        componentStack: errorInfo.componentStack,
                        url: window.location.href,
                        userAgent: navigator.userAgent
                    }),
                });
            } catch (err) {
                console.error("Failed to report error to backend:", err);
            }
        };

        reportError();
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="min-h-screen flex items-center justify-center bg-[#00150d] text-white p-4 font-sans">
                    <div className="max-w-md w-full bg-[#002517] p-8 rounded-2xl border border-emerald-900/50 shadow-2xl text-center">
                        <h1 className="text-3xl font-bold mb-4 text-emerald-400">Oops!</h1>
                        <p className="text-emerald-100/70 mb-8">
                            Something went wrong. We've been notified and are working on it.
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            className="bg-emerald-600 hover:bg-emerald-500 text-white font-semibold py-3 px-8 rounded-full transition-all active:scale-95 shadow-lg shadow-emerald-900/20"
                        >
                            Refresh Page
                        </button>
                        <div className="mt-6">
                            <a href="/" className="text-emerald-400/60 hover:text-emerald-400 text-sm transition-colors">
                                Back to Home
                            </a>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
